<template>
  <div class="character ru_RU">
    <h2 class="character__title">
      {{ model.title }} <span v-if="model.isRequired" class="color-red">*</span>
    </h2>
    <div class="character__wrap" :class="{'character__wrap--invalid': model.invalid}">
      <div v-show="model.invalid" class="character__popup">
        <p v-for="(error, i) in errors" :key="i">{{ error }}</p>
      </div>
      <div @click="toggle" class="character__top">
        <div v-show="!opened" class="character__placeholder">1. Выбор характеристики позиции</div>
        <button class="btn-toggle character__toggle"
                :class="{'character__toggle--opened': opened}">Toggle
        </button>
        <button v-tooltip="model.comment" @click.stop
                class="btn-toggle character__info" :disabled="!model.comment">Tooltip
        </button>
      </div>
      <div v-show="opened" class="character__content">
        <h3 class="character__title character__title--range">Диапазон</h3>
        <div class="range d-flex mb-5" v-for="(item, index) in model.values" :key="index">
          <label class="custom-checkbox" style="padding:0; margin:0">
            <input @change="update(item, index)" v-model="item.check" type="checkbox"
                   class="custom-checkbox__native sr-only">
            <span class="custom-checkbox__input"></span>
          </label>
          <div class="range__wrap">
            <label class="range__label">
              Ot
            </label>
            <div class="range__wrap">
              <input
                  disabled
                  :value="item.from"
                  class="range__input range__input--to" >
            </div>

          </div>
          <div class="range__wrap">

            <label class="range__label">
              Do
            </label>
            <div class="range__wrap">
              <input
                  disabled
                  :value="item.to"
                  class="range__input range__input--to" >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isNumber from '@/utilites/isNumber';

export default {
  name: 'range',
  props: ['model'],
  data() {
    return {
      range_num: undefined,
      opened: false,
      errors: [],
    };
  },
  mounted() {
    const decoded = [];
    const decoded2 = [];
    this.model.values.forEach((el) => {
      decoded.push(JSON.parse(el));
    });
    this.model.values = decoded;
    decoded.forEach((el) => {
      if (typeof el === 'string') {
        decoded2.push(JSON.parse(el));
      }
    });
    this.model.values = decoded2.length === 0 ? decoded : decoded2;

    this.model.values.forEach((el) => {
      el.check = false;
      let arr = el.from.match(/\d+/);
      el.from = arr !== null && arr.length >= 1 ? parseInt(arr[0]) : 'не задано';
      arr = el.to.match(/\d+/);
      el.to = arr !== null && arr.length >= 1 ? parseInt(arr[0]) : 'не задано';
    });
    if (this.model.isRequired) {
      this.errors.push('Необходимо заполнить это поле')
    }
  },
  methods: {
    update(item, index) {
      const { isRequired } = this.model;
      item.index = index;
      item.range_num = this.range_num;
      this.errors = [];
      if (!isNumber(item.from) && !isNumber(item.to) && isRequired) {
        this.errors.push('Необходимо заполнить это поле');
      }
      // else if ((!isNumber(item.range_num)
      //     || (isNumber(item.from) && item.from > item.range_num)
      //     || (isNumber(item.to) && item.range_num > item.to))) {
      //   let f, t = null;
      //   this.errors.push(
      //       this.$t(
      //           'over-range',
      //           {
      //             from: item.from,
      //             to: item.to
      //           }
      //       )
      //   );
      // }
      if (this.errors.length === 0) {
        this.model.invalid = false;
        this.model.values.forEach((va, i) => {
          if (va.index === item.index) {
            this.model[i] = item;
          }
        });

        this.$emit('update', {
          title: this.model.title,
          value: item,
          model: this.model,
        });
      } else {
        this.model.invalid = true;
      }
    },
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.mb-5 {
  margin-bottom: 5px;
}

.range {

  &__wrap {
    display: inline-block;
    position: relative;
    color: $black3;
    line-height: 1.1;
  }
}

.ru_RU .range {

  &__label {
    left: 15px;
    right: auto;
  }

  &__input {
    padding: 12px 5px 12px 35px;
  }
}

input[type=number] {
  --moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
